export const APP_CONFIG = Object.freeze({
  TOKEN: "L&D_ADMIN",
});
